import { useWidgetLocalStorageValue } from '@widgets/messenger/compositions/useWidgetLocalStorageValue'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import type { MessengerNewMessageState } from '@widgets/messenger/types/chat/chat'
import type { ChatScrollPosition } from '@widgets/shared/types'

type WidgetChatLocalStorageData = {
  token: string
  email: string
  newMessageState?: MessengerNewMessageState
  lastScrollPosition?: ChatScrollPosition
}

export const useChatLocalStorage = () => {
  const { uniqueCode, domain } = useWidgetStore()

  return useWidgetLocalStorageValue<WidgetChatLocalStorageData>(
    {
      uniqueCode: uniqueCode.value,
      domain: domain.value,
      dataKey: 'chat',
    },
    {
      token: '',
      email: '',
    },
  )
}
